import { sagaMiddleware } from '../store/configureStore';
import rootSaga from '../rootSaga';

sagaMiddleware.run(rootSaga);
